interface Props {
  detail: string;
  onResume: () => void;
  onReset: () => void;
}

/**
 * 검사를 중간에 멈춘 경우, intro 화면에 노출되는 "이어서 풀기" 안내 배너.
 */
export default function TestResumeBanner({ detail, onResume, onReset }: Props) {
  return (
    <div className="bg-accent-50 border border-accent-200 rounded-xl p-4">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg flex-shrink-0">
          <i className="ri-play-circle-line text-white text-lg"></i>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-foreground-950 text-sm mb-0.5">
            이어서 풀 수 있어요
          </div>
          <div className="text-foreground-600 text-xs mb-3">{detail}</div>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={onResume}
              className="whitespace-nowrap bg-accent-500 hover:bg-accent-600 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors cursor-pointer"
            >
              <i className="ri-play-line mr-1.5"></i>이어서 풀기
            </button>
            <button
              onClick={onReset}
              className="whitespace-nowrap border border-background-300 text-foreground-600 text-sm font-medium px-4 py-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            >
              처음부터 다시
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}